import { render, staticRenderFns } from "./CaseDetailPanel.vue?vue&type=template&id=18f7d8d6&scoped=true&"
import script from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
export * from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetailPanel.vue?vue&type=style&index=0&id=18f7d8d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7d8d6",
  null
  
)

export default component.exports